import { faker } from '@faker-js/faker'

import thumbnails from './thumbnails'

/**
 *
 */
export default function mockChannel({ override = {} } = {}) {
  const channel = {
    id: faker.string.uuid(),
    serviceId: faker.string.uuid(),
    name: faker.lorem.word(),
    avatar: thumbnails[0],
    isDisconnected: false,
    service: 'instagram',
    organizationId: faker.string.uuid(),
  }

  return {
    ...channel,
    ...override,
  }
}
